/**
 * Registro condicional da PWA candidato.
 * Com REACT_APP_ENABLE_PWA !== 'true' este módulo não faz nada (comportamento idêntico ao site atual).
 */

import { applyTenantPwaFromConfig } from './tenantPwaContract';

const PWA_ENABLED = process.env.REACT_APP_ENABLE_PWA === 'true';

export function isAuthDeepLinkUrl() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const view = params.get('view');
  return view === 'complete-registration' || view === 'reset-password';
}

/** iOS/Safari: SW em link de e-mail pode causar tela branca — não registrar neste fluxo. */
export function preparePwaForAuthDeepLink() {
  if (!PWA_ENABLED || typeof window === 'undefined') return;
  if (!isAuthDeepLinkUrl()) return;
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  }).catch(() => {});
}

function publicUrl(path) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${base}${path}`;
}

function injectManifestLink() {
  if (document.querySelector('link[rel="manifest"]')) return;
  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = publicUrl('/manifest-candidate.webmanifest');
  document.head.appendChild(link);
}

function injectAppleMeta() {
  if (!document.querySelector('meta[name="apple-mobile-web-app-capable"]')) {
    const cap = document.createElement('meta');
    cap.name = 'apple-mobile-web-app-capable';
    cap.content = 'yes';
    document.head.appendChild(cap);
  }
  if (!document.querySelector('meta[name="apple-mobile-web-app-title"]')) {
    const title = document.createElement('meta');
    title.name = 'apple-mobile-web-app-title';
    title.content = 'Ingressa';
    document.head.appendChild(title);
  }
  if (!document.querySelector('link[rel="apple-touch-icon"]')) {
    const icon = document.createElement('link');
    icon.rel = 'apple-touch-icon';
    icon.href = publicUrl('/pwa/icon-192.png');
    document.head.appendChild(icon);
  }
}

export function registerCandidatePwa() {
  if (!PWA_ENABLED) return;

  if (isAuthDeepLinkUrl()) return;

  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  fetch(`${base}/api/config`)
    .then((res) => (res.ok ? res.json() : null))
    .then((cfg) => {
      if (!cfg?.candidate_pwa_contracted) return;
      applyTenantPwaFromConfig(cfg);
      injectManifestLink();
      injectAppleMeta();
      if (!('serviceWorker' in navigator)) return;
      const registerSw = () => {
        navigator.serviceWorker
          .register(publicUrl('/sw-candidate.js'))
          .catch((err) => {
            console.warn('[Ingressa PWA] Service worker não registrado:', err);
          });
      };
      if (document.readyState === 'complete') registerSw();
      else window.addEventListener('load', registerSw);
    })
    .catch(() => {});
}
